import { GetApiIntroducerPortalIntroducerReintroductionSearchResponse } from '@iwoca/lapi-client/introducer_portal';
import { Label } from '@iwoca/orion';
import clsx from 'clsx';
import { PRIVACY_DISPLAY_CLASSES } from 'utils/privacyClasses';
import { CriteriaItem } from '../CriteriaItem/CriteriaItem';
import styles from '../NewSignupForm.module.css';

type TProps = {
  data: GetApiIntroducerPortalIntroducerReintroductionSearchResponse['data'];
};

export const ReintroducedSignupFields = ({ data }: TProps) => {
  return (
    <>
      <div className={styles.formField} data-testid="reintroduction-fields">
        <div>
          <span>Applicant's name</span>
          <div
            className={clsx(
              styles.reintroductionField,
              styles.reintroducedPersonField,
              PRIVACY_DISPLAY_CLASSES,
            )}
          >
            {data.first_name} {data.last_name}
          </div>
        </div>

        <div className={styles.criteria}>
          <CriteriaItem hasPassed testId="director">
            The main applicant must be a director of the company and prepared to
            provide a personal guarantee to support a loan.
          </CriteriaItem>
        </div>
      </div>

      <div className={styles.formField}>
        <div className={styles.labelWithTooltip}>
          <Label>Date of birth</Label>
        </div>
        <div className={clsx(styles.dobContainer, PRIVACY_DISPLAY_CLASSES)}>
          <div className={styles.reintroductionField}>{data.day_of_birth}</div>
          <div className={styles.reintroductionField}>
            {data.month_of_birth}
          </div>
          <div className={styles.reintroductionField}>{data.year_of_birth}</div>
        </div>
      </div>
    </>
  );
};
